const brands = 
[
        {
            "id": 43,
            "alt": "aynotdead",
            "tags":"Ecommerce",
            "titulo": "AY NOT DEAD"
        },{
            "id": 44,
            "alt": "mija",
            "tags":"Ecommerce",
            "titulo": "MIJA"
        },{
            "id": 39,
            "alt": "francocolapinto",
            "tags":"Ecommerce",
            "titulo": "Franco Colapinto"
        },{
            "id": 40,
            "alt": "notevaagustar",
            "tags":"Ecommerce",
            "titulo": "NTVG"
        },{
            "id": 38,
            "alt": "mundia",
            "texto":"MUNDÍA es volver a lo simple, a lo natural y a lo verdadero. Te invito a ser parte. Agustina Cherri.",
            "tags":"Ecommerce",
            "titulo": "Mundia"
        },{
            "id": 1,
            "alt": "duki",
            "texto":"Duki, es un rapero y compositor argentino. Se le acredita el haber popularizado el género del trap a nivel mundial.",
            "tags":"Ecommerce - Brand Site",
            "titulo": "Duki"
        },{
            "id": 4,
            "alt": "legionextranjera",
            "texto":"Orgullosos de desarrollar los productos más duraderos confeccionados en Argentina.",
            "tags":"Ecommerce-Brand site",
            "titulo": "Legion Extranjera"
        },{
            "id": 34,
            "alt": "lali",
            "texto":"Lali, una figura clave en la música latina pop.",
            "tags":"Ecommerce",
            "titulo": "Lali"
        },{
            "id": 14,
            "alt": "mercadolibre",
            "tags":"Ecommerce - Ads - Webs - Design - Developments",
            "titulo": "Mercado Libre"
        },{
            "id": 31,
            "alt": "nickinicole",
            "texto":"Nicki Nicole, una figura clave en la música latina urbana.",
            "tags":"Ecommerce",
            "titulo": "Nicki Nicole"
        },{
            "id": 5,
            "alt": "creciendo",
            "texto":"Más de 50 años junto a las familias argentinas! Descubrí nuestra nueva web y conocé productos seguros, innovadores y pensados para tu bebé.",
            "tags":"Ecommerce - Brand Site",
            "titulo": "Creciendo"
        },{
            "id": 13,
            "alt": "hudson",
            "tags":"Ecommerce - Brand Site",
            "titulo": "Hudson"
        },{
            "id": 19,
            "alt": "pastalinda",
            "tags":"Ecommerce - Brand Site",
            "titulo": "Pastalinda"
        },{
            "id": 20,
            "alt": "peabody",
            "tags":"Ecommerce - Brand Site",
            "titulo": "Peabody"
        },{
            "id": 22,
            "alt": "regina",
            "tags":"Ecommerce - Brand Site",
            "titulo": "Regina"
        },{
            "id": 36,
            "alt": "cazzu",
            "texto":"Julieta Emilia Cazzuchelli, conocida como Cazzu, es una cantante, rapera y compositora argentina",
            "tags":"Ecommerce - Brand Site",
            "titulo": "Cazzu"
        },{
            "id": 37,
            "alt": "tanbionica",
            "texto":"Tan Biónica es un grupo musical de rock argentino surgido en Buenos Aires en el año 2001 formado por Chano, Seby, Bambi y Diega.",
            "tags":"Ecommerce - Brand Site",
            "titulo": "Tan Bionica"
        },{
            "id": 2,
            "alt": "lego",
            "texto":"Tienda oficial del célebre brick de construcción con vínculos a productos, juegos, videos, la tienda LEGO®.",
            "tags":"Ecommerce",
            "titulo": "Lego"
        },{
            "id": 3,
            "alt": "chimmychurry",
            "tags":"Ecommerce - Brand Site",
            "titulo": "Chimmy Churry"
        },{
            "id": 6,
            "alt": "dia",
            "tags":"Ecommerce",
            "titulo": "Dia%"
        },{
            "id": 7,
            "alt": "educando",
            "tags":"Ecommerce - Brand Site",
            "titulo": "Educando"
        },{
            "id": 8,
            "alt": "fascino",
            "tags":"Ecommerce - Brand Site",
            "titulo": "Fascino"
        },{
            "id": 9,
            "alt": "garbarino",
            "tags":"Ecommerce",
            "titulo": "Garbarino"
        },{
            "id": 10,
            "alt": "herschel",
            "tags":"Ecommerce - Brand Site",
            "titulo": "Herschel"
        },{
            "id": 11,
            "alt": "cher",
            "tags":"Ecommerce - Brand Site",
            "titulo": "Cher"
        },{
            "id": 35,
            "alt": "bsastrap",
            "tags":"Ecommerce - Brand Site",
            "titulo": "Bs As Trap"
        },{
            "id": 12,
            "alt": "hidrolit",
            "tags":"Ecommerce",
            "titulo": "Hidrolit"
        },{
            "id": 15,
            "alt": "larpon",
            "tags":"Ecommerce - Brand Site",
            "titulo": "Larpon"
        },{
            "id": 16,
            "alt": "norauto",
            "tags":"Ecommerce",
            "titulo": "Norauto"
        },{
            "id": 17,
            "alt": "longvie",
            "tags":"Ecommerce - Brand Site",
            "titulo": "Longvie"
        },{
            "id": 18,
            "alt": "neumen",
            "tags":"Ecommerce",
            "titulo": "Neumen"
        },{
            "id": 21,
            "alt": "porongo",
            "tags":"Ecommerce - Brand Site",
            "titulo": "Porongo"
        },{
            "id": 23,
            "alt": "rimland",
            "tags":"Ecommerce - Brand Site",
            "titulo": "Rimland"
        },{
            "id": 24,
            "alt": "tecnocompro",
            "tags":"Ecommerce - Brand Site",
            "titulo": "Tecnocompro"
        },{
            "id": 25,
            "alt": "ariston",
            "tags":"Ecommerce - Brand Site",
            "titulo": "Ariston"
        },{
            "id": 26,
            "alt": "eslabondelujo",
            "tags":"Ecommerce - Brand Site",
            "titulo": "Eslabon de lujo"
        },{
            "id": 27,
            "alt": "infinit",
            "tags":"Ecommerce",
            "titulo": "Infinit"
        },{
            "id": 28,
            "alt": "karcher",
            "tags":"Ecommerce",
            "titulo": "Karcher"
        },{
            "id": 29,
            "alt": "cencosud",
            "tags":"Ecommerce - App - Design - Digital Catalogues",
            "titulo": "Cencosud"
        },{
            "id": 29,
            "alt": "ypf",
            "titulo": "YPF",
            "tags":"App"
        },{
            "id": 30,
            "alt": "mondelez",
            "tags":"Design - Apps, Digital Support",
            "titulo": "Mondelez"
        },{
            "id": 32,
            "alt": "chevrolet",
            "tags":"Ecommerce",
            "titulo": "Chevrolet"
        },{
            "id": 41,
            "alt": "nap",
            "tags":"Ecommerce - Brand Site - Mayorista - Minorista",
            "titulo": "Tienda Nap"
        },{
            "id": 42,
            "alt": "fervor",
            "tags":"Ecommerce - Brand Site",
            "titulo": "Fervor Baires"
        }
]
export default brands